import { StyleSheet } from '@react-pdf/renderer';
import odoLogo from '../assets/odo-logo-res.png';

// No custom font: fontkit can't embed woff2 (fatal RangeError in `_addGlyph`);
// built-in Helvetica ships Helvetica-Bold for fontWeight 600/700.

export const ODO_LOGO_URL = odoLogo;

const COLORS = {
    black: '#000000',
    neutral950: '#0a0a0a',
    neutral600: '#525252',
    neutral100: '#f5f5f5',
    gray100: '#f3f4f6',
    gray600: '#4b5563',
    divider: '#d4d4d4',
    white: '#ffffff'
} as const;

export const shared = StyleSheet.create({
    page: {
        fontFamily: 'Helvetica',
        fontSize: 11,
        padding: '24 24 24 24',
        backgroundColor: COLORS.white,
        color: COLORS.black,
        display: 'flex',
        flexDirection: 'column'
    },
    pageContent: {
        flex: 1
    },
    header: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 12
    },
    title: {
        fontSize: 20,
        fontWeight: 600
    },
    logo: {
        height: 44,
        width: 78,
        objectFit: 'contain'
    },
    infoRow: {
        flexDirection: 'row',
        gap: 16,
        marginTop: 12
    },
    infoCell: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
        gap: 8
    },
    infoLabel: {
        fontSize: 10,
        color: COLORS.neutral950
    },
    infoValue: {
        flex: 1,
        height: 22,
        backgroundColor: COLORS.neutral100,
        borderRadius: 3,
        paddingHorizontal: 8,
        justifyContent: 'center'
    },
    infoValueText: {
        fontSize: 10
    },
    divider: {
        borderBottomWidth: 1,
        borderBottomColor: COLORS.divider,
        marginVertical: 10
    },
    elasticsRow: {
        flexDirection: 'row',
        gap: 20,
        marginTop: 8
    },
    elasticColumn: {
        flex: 1,
        gap: 8
    },
    elasticField: {
        flexDirection: 'row',
        alignItems: 'center'
    },
    elasticLabel: {
        width: '40%',
        fontSize: 11,
        color: COLORS.neutral600
    },
    elasticValue: {
        flex: 1,
        height: 20,
        backgroundColor: COLORS.neutral100,
        borderRadius: 3,
        paddingHorizontal: 6,
        justifyContent: 'center'
    },
    elasticValueText: {
        fontSize: 10
    },
    sectionTitle: {
        fontSize: 13,
        fontWeight: 600,
        marginBottom: 6
    },
    notesBox: {
        backgroundColor: COLORS.gray100,
        borderRadius: 4,
        minHeight: 80,
        padding: 12,
        marginTop: 6
    },
    notesText: {
        fontSize: 11
    },
    warningText: {
        fontSize: 9,
        color: COLORS.neutral600,
        lineHeight: 1.5
    },
    boldWarningText: {
        fontSize: 10,
        fontWeight: 600
    },
    warningEmphasis: {
        fontSize: 9,
        fontWeight: 700,
        textDecoration: 'underline'
    },
    section: {
        marginTop: 8
    },
    scheduleRow: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 8,
        marginTop: 8
    },
    scheduleLabel: {
        width: '50%',
        fontSize: 11,
        color: COLORS.neutral600
    },
    scheduleValue: {
        flex: 1,
        height: 20,
        backgroundColor: COLORS.neutral100,
        borderRadius: 3,
        paddingHorizontal: 6,
        justifyContent: 'center'
    },
    scheduleValueText: {
        fontSize: 10
    },
    footer: {
        alignItems: 'flex-end',
        marginTop: 2
    },
    footerText: {
        fontSize: 8,
        color: COLORS.gray600
    },
    helpLinksContainer: {
        marginTop: 12,
        gap: 4
    },
    helpLinkText: {
        fontSize: 9,
        color: COLORS.neutral600,
        lineHeight: 1.5
    },
    helpLink: {
        color: '#007E87',
        textDecoration: 'underline'
    }
});

export { COLORS };
